export const CONCEPTS = [
    { id: 1, name: "Furicane" },
    { id: 2, name: "Amberclaw" },
    { id: 3, name: "Satoshisaurus" },
    { id: 4, name: "Bruce" },
    { id: 5, name: "Glitterrex" }
];

export const INITIAL_STATE = {
    isConnected: false,
    connectionStatus: "Connect",
    selectedConcept: 1,
    publicMint: false,
    whitelistMint: false,
    price: "0",
    maxMint: 1,
    selectedChain: 'Base',
    selectedChainNo: 3,
    mintAmount: 1,
    currentSupply: 0,
    maxSupply: 8888,
    isWhitelisted: false,
    votesConcept: {
        1: 1240, 2: 1240, 3: 1240, 4: 1240, 5: 1240
    },
    chainConcept: {
        1: 0, 2: 0, 3: 0, 4: 0, 5: 0, 6: 0, 7: 0, 8: 0
    },
    isModalOpen: false
};